// SUPER USER reducer types
export const SET_ADMIN_AUTHENTICATED = "SET_ADMIN_AUTHENTICATED";
export const ADMIN_LOGED_IN = "ADMIN_LOGED_IN";
export const ADMIN_LOGING_IN = "ADMIN_LOGING_IN";
export const ADMIN_LOGING_IN_STATUS = "ADMIN_LOGING_IN_STATUS";
export const CLEAR_ADMIN_LOG_IN = "CLEAR_ADMIN_LOG_IN";
export const SET_ADMIN_UNAUTHENTICATED = "SET_ADMIN_UNAUTHENTICATED";

// reducers types
export const SET_APPCHECKTOKEN = "SET_APPCHECKTOKEN";
export const SEND_CONTACTBYEMAIL = "SEND_CONTACTBYEMAIL";
export const SENDING_CONTACTBYEMAIL = "SENDING_CONTACTBYEMAIL";
export const CLEAR_SEND_CONTACTBYEMAIL = "CLEAR_SEND_CONTACTBYEMAIL";
export const SUBSCRIBE_NEWSLETTER = "SUBSCRIBE_NEWSLETTER";
export const SUBSCRIBING_NEWSLETTER = "SUBSCRIBING_NEWSLETTER";
export const CLEAR_SUBSCRIBE_NEWSLETTER = "CLEAR_SUBSCRIBE_NEWSLETTER";
// UI reducer types
export const LOADING_ALLPROJECTS = "LOADING_ALLPROJECTS";
// Data reducer  types
export const GET_ALL_PROJECTS = "GET_ALL_PROJECTS";
